import { Box, styled } from "@mui/material";

export const BybNotificationDot = styled(Box)(({ theme }) => ({
  width: theme.spacing(1.25),
  height: theme.spacing(1.25),
  borderRadius: "50%",
  backgroundColor: theme.palette.dsDestructive.v400,
}));
